// 曜日 × 時間帯ヒートマップ
//   月曜=1 〜 日曜=0 だが、表示は月〜日の順に並べ替える
import type { WdayHourCell } from '../../lib/salesAnalytics';

interface Props {
  cells: WdayHourCell[];
  minHour: number;
  maxHour: number;
  metric: 'txnCount' | 'sales';
}

const WDAY_ORDER = [1, 2, 3, 4, 5, 6, 0]; // 月火水木金土日
const WDAY_LABEL: Record<number, string> = {
  0: '日',
  1: '月',
  2: '火',
  3: '水',
  4: '木',
  5: '金',
  6: '土',
};

export const WdayHourGrid = ({ cells, minHour, maxHour, metric }: Props) => {
  const max = Math.max(...cells.map((c) => (metric === 'sales' ? c.sales : c.txnCount)), 1);
  const lookup = new Map<string, WdayHourCell>();
  for (const c of cells) lookup.set(`${c.wday}-${c.hour}`, c);

  const hours: number[] = [];
  for (let h = minHour; h <= maxHour; h++) hours.push(h);

  return (
    <div style={{ overflowX: 'auto' }}>
      <table style={{ borderCollapse: 'collapse', fontSize: 11 }}>
        <thead>
          <tr>
            <th style={{ ...thStyle, minWidth: 32 }}></th>
            {hours.map((h) => (
              <th key={h} style={{ ...thStyle, minWidth: 32, textAlign: 'center' }}>
                {h}時
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {WDAY_ORDER.map((w) => (
            <tr key={w}>
              <th style={{ ...thStyle, textAlign: 'center', background: '#f8f9fa' }}>
                {WDAY_LABEL[w]}
              </th>
              {hours.map((h) => {
                const c = lookup.get(`${w}-${h}`);
                const v = c ? (metric === 'sales' ? c.sales : c.txnCount) : 0;
                const ratio = v / max;
                const bg = v > 0 ? `rgba(201,42,42,${0.08 + ratio * 0.85})` : '#f8f9fa';
                const color = ratio > 0.55 ? '#fff' : '#212529';
                return (
                  <td
                    key={h}
                    style={{
                      ...tdStyle,
                      background: bg,
                      color,
                      textAlign: 'center',
                      minWidth: 32,
                    }}
                    title={
                      c
                        ? `${WDAY_LABEL[w]} ${h}時 / 売上 ¥${c.sales.toLocaleString()} / 取引 ${c.txnCount}`
                        : '—'
                    }
                  >
                    {v > 0
                      ? metric === 'sales'
                        ? Math.round(v / 1000) + 'k'
                        : v
                      : ''}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const thStyle: React.CSSProperties = {
  padding: '2px 4px',
  border: '1px solid #f1f3f5',
  fontWeight: 600,
  color: '#495057',
};
const tdStyle: React.CSSProperties = {
  padding: '4px 6px',
  border: '1px solid #f1f3f5',
};
